import React from "react";

function ApiReference({ apiInfo, schema }) {
  if (!apiInfo) return <p className="text-muted">No API information available.</p>;

  const baseUrl = apiInfo.base_url;

  return (
    <div className="api-reference">
      <section className="doc-section">
        <h2>Authentication</h2>
        <p>All requests use an API key in the Authorization header.</p>
        <pre className="doc-code">
          <code>{`${apiInfo.auth.header}`}</code>
        </pre>
        <p className="text-muted">
          Get your API key from the CRM team. Sandbox keys are available for
          testing without touching production data.
        </p>
      </section>

      <section className="doc-section">
        <h2>Base URL</h2>
        <pre className="doc-code">
          <code>{baseUrl}</code>
        </pre>
      </section>

      <section className="doc-section">
        <h2>Inbound Endpoints</h2>
        <table className="doc-table">
          <thead>
            <tr>
              <th>Method</th>
              <th>Path</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {apiInfo.endpoints.inbound.map((e) => (
              <tr key={e.path}>
                <td><code>{e.method}</code></td>
                <td><code>{e.path}</code></td>
                <td>{e.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="doc-section">
        <h2>Outbound Endpoints</h2>
        <table className="doc-table">
          <thead>
            <tr>
              <th>Method</th>
              <th>Path</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {apiInfo.endpoints.outbound.map((e) => (
              <tr key={e.path}>
                <td><code>{e.method}</code></td>
                <td><code>{e.path}</code></td>
                <td>{e.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="doc-section">
        <h2>Payload Schema</h2>
        {schema?.payload && (
          <pre className="doc-code">
            <code>{JSON.stringify(schema.payload, null, 2)}</code>
          </pre>
        )}
      </section>

      <section className="doc-section">
        <h2>Rate Limits</h2>
        <ul>
          <li>Read: <strong>{apiInfo.rate_limits.read_per_minute} / minute</strong></li>
          <li>Write: <strong>{apiInfo.rate_limits.write_per_minute} / minute</strong></li>
          <li>File: <strong>{apiInfo.rate_limits.file_per_minute} / minute</strong></li>
          <li>Sandbox: <strong>{apiInfo.rate_limits.sandbox_any_per_minute} / minute</strong></li>
        </ul>
        <p className="text-muted">
          Exceeded limits return HTTP 429 with a Retry-After header.
        </p>
      </section>

      <section className="doc-section">
        <h2>Example — Create a Lead</h2>
        <pre className="doc-code">
          <code>{`curl -X POST ${baseUrl}/api/external/leads \\
  -H "Authorization: Bearer ivsg_key_xxxxxxxx" \\
  -H "Content-Type: application/json" \\
  -d '{
    "leads": [{
      "external_source": "partner_xyz",
      "external_id": "lead-12345",
      "external_updated_at": "2026-09-20T14:30:00Z",
      "owns_fields": ["status"],
      "lead": {
        "company": "123 Ford",
        "email": "info@123ford.example",
        "status": "Qualified",
        "lead_source": "DFC"
      }
    }]
  }'`}</code>
        </pre>
      </section>
    </div>
  );
}

export default ApiReference;